import { lazy } from "react";

export const LazyAdminToolsPage = lazy(
    () => import(/* webpackChunkName: "AdminToolsPage" */ "./AdminToolsPage")
);
